<template>
  <v-app >
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
        <v-row >
          <v-col>
            <v-card
                class="mb-12"
                color="#393E46"
            >
              <v-card-title>
                <v-btn icon :top="top" :right="right" @click="$router.push({name:'Eventos'})">
                  <v-icon>far fa-times-circle</v-icon></v-btn>
                <v-btn icon :top="top" :right="right" @click="$router.go(-1)">
                <v-icon>fas fa-long-arrow-alt-left</v-icon></v-btn>
              </v-card-title>
              <v-card-text >
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                <v-row justify="center" align="center">
                  <v-col cols="12" md="12" lg="12" sm="12">
                    <h1 class="text-lg-h3 text-md-h3 text-h4 text-center"> Escoger Tipo de Pago en el Evento</h1>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="12" md="12" lg="12" sm="12">
                   <h2 class="text-center"> Escoge si tu evento es de cortesia y/o pago </h2>
                  </v-col>
                    </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="10" lg="10" sm="12">
                     <v-radio-group row  v-model="idTipoEvento"  :rules="[rules.required]" :mandatory="false">
                      <template v-for="tipovv in TipoEventos">
                        <v-radio off-icon="" on-icon="" name="idTipoEvento" :key="tipovv.id"
                                  :value="tipovv.id" active-class="active">
                          <template v-slot:label>
                            <v-card   class="categoria"  >
                              <v-card-text>
                                <v-row align="center" class="text-center" >
                                  <v-col cols="12">
                                    <v-icon large>{{tipovv.icono}}</v-icon>
                                  </v-col>
                                </v-row>
                                <v-row class="text-center">
                                  <v-col>
                                    {{tipovv.tipoEvento}}
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </template>
                        </v-radio>
                      </template>
                    </v-radio-group> </v-col></v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3" lg="3" sm="12">
                   <v-btn class="primary" @click="irpaso3">Ir a Paso 3 </v-btn>
                  </v-col>
                </v-row>

                </v-form>
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>
        <leftmenueventos :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import moment from "moment";
import piepagina from "@/components/general/piepagina";
import Leftmenueventos from "@/components/general/leftmenueventos";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Crear Evento Paso 2 | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    Leftmenueventos,
    piepagina
  },
  data: () => ({
    drawer: null,
    overlay:false,
    progr: true,
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    categoriafiesta: 0,
    tipoevento: 0,
    steps: 4,
    e1: 1,
    top:true,
    valid:true,
    rules: {
      required: value => !!value || 'Requerido.',
    },
    right:true,
    direction:'top',
    imagen:null,
    edialog: false,
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    idTipoEvento: 1,
    idCategoriaEvento:0,
    abreviado:'NN',

    time: null,
    time2: null,
    TipoEventos: [],
    search: '',
    defaultItem: {
      activo: true,
      aforo: 0,
      cabecera: "",
      cliente: {},
      contactos: [],
      createdAt: null,
      descripcion: "",
      eventoCategoria: {},
      fechaFinal: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechaInicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      flyer: "",
      footer: "",
      foto: "",
      horaFinal: "00:00:00",
      horaInicio: "00:00:00",
      id: null,
      lat: 0,
      listaapp: true,
      lng: 0,
      nombre: "",
      promotorcambia: true,
      publicoapp: true,
      qrmail: true,
      tag: "",
      tipoEvento: {},
      ubicacion: "",
      ventapp: true,
    },
    token:'',
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Zonas', value: 'zonas', sortable: false },
      { text: 'Tickets', value: 'tickets', sortable: false },
      { text: 'Contactos', value: 'promotores', sortable: false },
      { text: 'Evento', align: 'left',  value: 'nombre'},
      { text: 'Fecha', value: 'fechai' },
      { text: 'Activo', value: 'activ', sortable: false }

    ]
  }),
  mounted (){
    if(this.cliente == null){
      this.$router.push({ name: 'creacliente' });
    }else{
      if (this.cliente.id > 0){
        this.defaultItem = this.evento;
        this.idTipoEvento = this.defaultItem.tipoEvento.id
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.idCategoriaEvento = this.defaultItem.eventoCategoria.id
        this.dameTiposEventos();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno


      }else{
        this.$router.push({ name: 'creacliente' });
      } }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    date () {
      this.defaultItem.fechaInicio = this.formatDate(this.date)
    },
    date2 () {
      this.defaultItem.fechaFinal = this.formatDate(this.date2)
    },
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    remove (item) {
      const index = this.SelectedEventoContacots.indexOf(item)
      if (index >= 0) this.SelectedEventoContacots.splice(index, 1)
    },
    irpaso3() {
      this.$refs.form.validate()
      if (this.valid){
      this.defaultItem.tipoEvento =this.TipoEventos.find(x=>x.id ===this.idTipoEvento)
      store.dispatch("fetchEvento", this.defaultItem);
      this.$router.push({name:'CreaPaso3'});
      }
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dameTiposEventos(){
      this.overlay = true;
      axios
          .get('tipoeventos',{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response.data)
            for (const entry of response.data) {
              if(entry.id){
              this.TipoEventos.push(entry)}

            }
            this.idTipoEvento = 1
            if(this.idCategoriaEvento === 8 || this.idCategoriaEvento === 5 || this.idCategoriaEvento === 7 ){
              this.idTipoEvento = 2
              this.defaultItem.tipoEvento =this.TipoEventos.find(x=>x.id ===this.idTipoEvento)
              store.dispatch("fetchEvento", this.defaultItem);
              this.$router.push({name:'CreaPaso3'});
            }
              if(this.idCategoriaEvento === 9){
                  this.idTipoEvento = 2
                  this.defaultItem.tipoEvento =this.TipoEventos.find(x=>x.id ===this.idTipoEvento)
                  store.dispatch("fetchEvento", this.defaultItem);
                  this.$router.push({name:'CreaPasoJuego'});
              }
            this.$refs.form.validate()

            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },



  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Evento' : 'Editar Evento'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente",
      evento: "evento"
    })
  }
};
</script>
<style>
.v-radio.theme--dark.active .categoria.v-card.v-sheet.theme--dark {
  border: 2px solid red !important;
  background-color: red;
}
.categoria.v-card.v-sheet.theme--dark{
  background-color: rgb(109, 152, 134);
  border-color: rgb(109, 152, 134);
  width: 200px;
}

</style>
